export default {
  methods: {
    makeid() {
      var text = ""
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      return text
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    getRandomInt(min, max) {
      if (typeof max !== "number") max = this.getRandomInt(0, 10)
      if (typeof min !== "number") min = max - this.getRandomInt(0, 10)
      return Math.floor(Math.random() * (max - min) + min)
    },
    newtab(url) {
      window.open(url, "_blank")
    },
    newtabout(url) {
      if (url.match(/https?:\/\//) === null) url = "http://" + url
      window.open(url, "_blank")
    },
    formatNumber(num) {
      let dico = ["K", "M", "B"]
      let cpy = Number(num)

      if (cpy < 1000) return cpy
      else {
        cpy /= 1000
        let index = 0
        while (cpy > 1000 && index < dico.length) {
          cpy /= 1000
          index++
        }
        return cpy.toFixed(0) + dico[index]
      }
    },
    addHttps(link) {
      if (typeof link === "string") {
        if (!link.startsWith("http://") && !link.startsWith("https://"))
          return `https://${link}`
        else return link
      } else return ""
    },
  },
}
